import { ICommentResponse } from './IComment';
import { eAuthorType } from './eAuthorTypes';
import { eCommentType } from './eCommentType';

export type IVendorCommentData = ICommentResponse;

export const createDefaultCommentData = (overrides?: Partial<ICommentResponse>): IVendorCommentData => ({
  author: {
    fullName: overrides?.author?.fullName ?? '',
    id: overrides?.author?.id ?? '',
    type: overrides?.author?.type ?? eAuthorType.Admin,
  },
  content: overrides?.content ?? '',
  createdAt: overrides?.createdAt ?? '',
  updatedAt: overrides?.updatedAt ?? '',
  type: overrides?.type ?? eCommentType.titleSearch,
  id: overrides?.id ?? '',
  vendorCompany: overrides?.vendorCompany ?? undefined,
});

export const convertFromCommentResponseToCommentData = (data: ICommentResponse): IVendorCommentData => data;
export const convertFromCommentArrayResponseToCommentDataArray = (data: ICommentResponse[]): IVendorCommentData[] =>
  data;
export const convertFromCommentDataToCommentResponse = (data: IVendorCommentData): ICommentResponse => data;
